export class UbicacionEntity {
    constructor(
        public Codigo?: number,
        public Nombre?: string
    ) { }
}
export class UbicacionEntityEmpresa {
    constructor(
        public Codigo?: number,
        public Nombre?: string,
        public Descripcion?: string
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/ubicacion_entity.ts